import {
    selectedRecordsField,
    updatedRecordsField,
} from 'app/shared-components/BatchActions/BatchUpdate/BatchUpdate.utils'
import {
    UpdateFormFields,
} from 'app/shared-components/BatchActions/BatchUpdate/BatchUpdate.types'

import {
    FeedbackFormFields,
} from 'app/shared-components/BatchActions/components/UploadFeedback/UploadFeedback.types'
import {
    LaneFeesFilterRequestResponse,
} from '../LaneFees.types'

export const updateFormFields: UpdateFormFields<LaneFeesFilterRequestResponse> = [{
    title: '',
    fields: [
        selectedRecordsField,
        {
            name: 'validTo',
            labelKey: 'LaneFees.validTo',
            componentName: 'DateSelect',
            required: true,
        },
    ],
}]

export const feedbackFormFields: FeedbackFormFields<LaneFeesFilterRequestResponse> = [{
    title: '',
    fields: [
        selectedRecordsField,
        updatedRecordsField,
        {
            name: 'validTo',
            labelKey: 'LaneFees.validTo',
            componentName: 'InputSingleline',
            disabled: true,
        },
    ],
}]
